import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { mergeCssModules, handleEvent, getDOMEventValue, mapToCssModules } from '@emoney/kyber-helpers';
import classNames$1 from 'classnames';
import React__default, { forwardRef } from 'react';
import defaultCssModule from './less/input.module.less.js';

/**
 * The Input primitive is an extremely thin wrapper around a DOM input
 * that normalizes the onChange and onBlur callbacks and adds some
 * appropriate default classes.
 */

var Input = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var cssModuleProp = _ref.cssModule,
      className = _ref.className,
      restProps = _objectWithoutPropertiesLoose(_ref, ["cssModule", "className"]);

  var cssModule = mergeCssModules(cssModuleProp, defaultCssModule);

  var handleChange = function handleChange(event) {
    handleEvent({
      event: event,
      method: 'onChange',
      props: restProps,
      value: getDOMEventValue(event)
    });
  };

  var handleBlur = function handleBlur(event) {
    handleEvent({
      event: event,
      method: 'onBlur',
      props: restProps,
      value: getDOMEventValue(event)
    });
  };

  var classes = mapToCssModules(classNames$1('input'), cssModule);
  return /*#__PURE__*/React__default.createElement("input", _extends({}, restProps, {
    className: classNames$1(classes, className),
    onChange: handleChange,
    onBlur: handleBlur,
    ref: ref
  }));
});
Input.displayName = 'Input';

export default Input;
